import { useActiveLocation } from "@/contexts/ActiveLocationContext";
import { Building2, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CenterSwitcherPill() {
  const { isMultiCenter, activeLocationId, userLocations, openCenterPicker } = useActiveLocation();

  if (!isMultiCenter) return null;

  const activeName = userLocations.find((l) => l.location_id === activeLocationId)?.name || "Select Centre";

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={openCenterPicker}
      className="h-8 gap-1.5 px-3 text-xs font-semibold border-primary/20 bg-primary/5 hover:bg-primary/10 text-primary"
    >
      <Building2 className="h-3.5 w-3.5" />
      <span className="max-w-[120px] truncate">{activeName}</span>
      <ChevronDown className="h-3 w-3 opacity-60" />
    </Button>
  );
}
